<template>
  <div class="hr-content-field" data-test-id="hr-content-field">
    <div data-test-id="hr-content-field__label" v-html="modelValue?.label" />
    <p
      class="__helper"
      data-test-id="hr-content-field__helper"
      v-html="modelValue?.help?.hint"
    />
  </div>
</template>

<script>
export default {
  name: 'hr-content-field',
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style>
.__helper {
  margin-top: 4px;
  font-size: 14px;
  color: var(--co-text-secondary);
}
</style>
